import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {isMobileGuard} from "@app/presentation/guards/is-mobile.guard";
import {ContactComponent} from "@app/presentation/pages/contact/contact.component";
import {LoginComponent} from "@app/presentation/pages/login/login.component";
import {ResetPasswordComponent} from "@app/presentation/pages/reset-password/reset-password.component";
import {
  SelectDeliveryPointComponent
} from "@app/presentation/pages/select-delivery-point/select-delivery-point.component";
import {SignUpComponent} from "@app/presentation/pages/sign-up/sign-up.component";
import {
  ChangeDeliveryPointComponent
} from "@app/presentation/pages/change-delivery-point/change-delivery-point.component";
import {
  CreateDeliveryPointComponent
} from "@app/presentation/pages/create-delivery-point/create-delivery-point.component";

import {hasDeeplinkGuard} from "@app/presentation/guards/has-deeplink.guard";
import {handlePathWithoutLangPrefixGuard} from "@app/presentation/guards/handle-path-without-lang-prefix-guard";
import {openOnModalGuard} from "@app/presentation/guards/open-on-modal-guard";

export const routesNames = {
  landingPage: "!landing-page",
  home: "home",
  contact: "contact",
  deliveryPoint: "delivery-point",
  login: "login",
  signUp: "sign-up",
  ecommerce: '!ecommerce',
  employeeRegister: "employee-register",
  search: "search",
  resetPassword: "reset-password",
  productDetails: "product-detail",
  comparison: "comparison",
  catalog: "catalog",
  scanner: "scanner",
  categories: "!categories",
  account: "account",
  accountConfig: "!account-config",
  personalData: "personal-data",
  commercialData: "commercial-data",
  deliveryPoints: "delivery-points",
  changeEmail: "change-email",
  changePassword: "change-password",
  changeDeliveryPoint: "!change-delivery-point",
  createDeliveryPoint: "!create-delivery-point",
  lists: 'lists',
  listDetail: 'list-detail',
  addToList: 'add-to-list',
  orderList: 'order-list',
  repeatOrder: 'repeat-order',
  listMenu: 'list-menu',
  deleteDeliveryPoint: 'delete-delivery-point',
  usualPurchase: 'usual-purchase',
  promotionDetail: 'promotion-detail',
  cartDetail: '!cart-detail',
  checkout: 'checkout',
  cart: 'cart',
  deliveryDate: 'delivery-date',
  payment: 'payment',
  taxData: 'tax-data',
  coupons: 'coupons',
  cookiesDeclaration: '!cookies-declaration',
  serviceUnavailable: '!service-unavailable',
  signUpCustomerCompany:'!sing-up-customer-company',
  pdfCatalog:'pdf-catalog',
  languageSelector: '!language-selector',
  shared: 'shared',
  paymentMethods: 'payment-methods',
}


export const routes: Routes = [
  {
    path: '', loadChildren: () => import('./presentation/pages/menu/menu.module').then(m => m.MenuModule),
    canActivate: [hasDeeplinkGuard],
    data: {
      discriminantPathKey: 'MENU'
    }
  },
  {
    path: routesNames.landingPage,
    loadChildren: () =>
      import("./presentation/pages/landing-page/landing-page.module").then((m) => m.LandingPageModule)
  },
  {
    path: routesNames.contact,
    canActivate: [isMobileGuard],
    component: ContactComponent,
  },
  {
    path: routesNames.login,
    canActivate: [isMobileGuard],
    component: LoginComponent,
  },
  {
    path: routesNames.search,
    loadChildren: () =>
      import("./presentation/pages/search/search.module").then(
        (m) => m.SearchModule
      ),
  },
  {
    path: routesNames.scanner,
    loadChildren: () => import("@app/presentation/pages/scanner/scanner.module").then((m) => m.ScannerModule)
  },
  {
    path: routesNames.resetPassword,
    canActivate: [isMobileGuard],
    component: ResetPasswordComponent
  },
  {
    path: routesNames.deliveryPoint,
    canActivate: [isMobileGuard],
    component: SelectDeliveryPointComponent,
  },
  {
    path: routesNames.signUp,
    canActivate: [isMobileGuard],
    component: SignUpComponent,
  },
  {
    path: `${routesNames.ecommerce}/${routesNames.employeeRegister}`,
    loadChildren: () =>
      import('@app/presentation/pages/sign-up-employee/sign-up-employee.module').then(m => m.SignUpEmployeeModule)
  },
  {
    path: routesNames.changeDeliveryPoint,
    canActivate: [isMobileGuard],
    component: ChangeDeliveryPointComponent,
  },
  {
    path: routesNames.createDeliveryPoint,
    canActivate: [isMobileGuard],
    component: CreateDeliveryPointComponent,
  },
  {
    path: routesNames.addToList,
    canActivate: [isMobileGuard],
    loadChildren: () =>
      import("@app/presentation/pages/add-to-list/add-to-list.module").then((m) => m.AddToListModule),
  },
  {
    path: routesNames.listMenu,
    canActivate: [isMobileGuard],
    loadChildren: () =>
      import("@app/presentation/pages/list-menu/list-menu.module").then((m) => m.ListMenuModule),
  },
  {
    path: routesNames.deleteDeliveryPoint,
    canActivate: [isMobileGuard],
    loadChildren: () =>
      import("@app/presentation/pages/delete-delivery-point/delete-delivery-point.module").then((m) => m.DeleteDeliveryPointModule),
  },
  {
    path: routesNames.checkout,
    loadChildren: () =>
      import('@app/presentation/pages/checkout/checkout.module').then(m => m.CheckoutModule),
    data: { skipRouteLocalization: true }
  },
  {
    path: routesNames.checkout,
    loadChildren: () =>
      import('@app/presentation/pages/checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: routesNames.serviceUnavailable,
    loadChildren: () =>
      import('@app/presentation/pages/service-unavailable/service-unavailable.module').then(m => m.ServiceUnavailableModule),
  },
  {
    path: routesNames.signUpCustomerCompany,
    loadChildren: () =>
      import('@app/presentation/pages/sign-up-customer-company/sign-up-customer-company.module').then(m => m.SignUpCustomerModule),
  },
  {
    path: routesNames.languageSelector,
    loadChildren: () =>
      import('@app/presentation/pages/language-selector/language-selector.module').then(m => m.LanguageSelectorModule),
  },
  {
    canActivate: [openOnModalGuard],
    path: routesNames.shared,
    loadComponent: () => import('@app/presentation/pages/shared-products/shared-products.component').then(m => m.SharedProductsComponent),
  },
  {
    path: '**',
    canActivate: [handlePathWithoutLangPrefixGuard],
    // Load menu module because we can use canActivate with redirect.
    loadChildren: () => import('./presentation/pages/menu/menu.module').then(m => m.MenuModule),
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: "top",
    initialNavigation: 'disabled'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
